// extracted by mini-css-extract-plugin
export default {"groupField":"DetailsFieldsList_groupField__FoYyF"};